// extracted by mini-css-extract-plugin
export default {"root":"EditListingDetailsPanel_root__PDr3b","form":"EditListingDetailsPanel_form__9dffL"};